import ufeApi from 'services/api/ufeApi';

async function validateAddress({ city, state, postalCode, country }) {
    const url = '/gway/v1/dotcom/util/location/validate';

    const data = await ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify({ city, state, postalCode, country })
    });

    if (data.errorCode) {
        throw data;
    }

    return data;
}

export default validateAddress;
